'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { ContactForm } from '@eliadmin/core/src/components/contact/contact-form';
import { CaptchaProvider } from '@eliadmin/core/src/components/providers/captcha-provider';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const CustomFooterContact = ({ apiKeys }: { apiKeys: any }) => {
  const locale = useLocaleStore(s => s.currentLocale);
  const { t } = useTranslations();
  const pathname = usePathname();

  function contactByLocale(locale: string): string {
    const urlMap: { [key: string]: string } = {
      sk: '/kontakt',
      en: '/en/kontakt',
      de: '/de/kontakt',
    };
    return `${urlMap[locale] || urlMap['sk']}`;
  }

  const contactUrl = contactByLocale(locale);

  return (
    <>
      {pathname !== contactUrl && (
        <section className={cn('', 'ea-contact-form__section')}>
          <Container className={cn('', 'ea-contact-form__container')}>
            <h2 data-ea-visual-tag="h3" className={cn('', 'ea-contact-form__title')}>
              {t('text569')}
            </h2>
            <CaptchaProvider reCaptchaKey={apiKeys.data.captcha.site_key}>
              <ContactForm />
            </CaptchaProvider>
          </Container>
          <Image
            src={'/images/triangle-design.svg'}
            alt={t('text569')}
            width={0}
            height={0}
            className={cn('', 'ea-contact-form__triangle-design')}
          />
        </section>
      )}
    </>
  );
};
